import React, { useContext, useEffect } from 'react'
import AppointmentForm from '../BoxPage/AppointmentForm'
import dayjs from 'dayjs'
import { put } from '../../Common/api'
import GlobalContext from '../GlobalContext'
import { t } from 'i18next'

export default function AdminAppointmentForm ({ appointment, form, setLoading }) {
  const { notificationApi } = useContext(GlobalContext)

  useEffect(() => {
    const json = {
      ...appointment,
      range: [dayjs(appointment.begin_date), dayjs(appointment.end_date)],
      appointment_date: dayjs(appointment.appointment_date),
      start: dayjs(appointment.start),
      created_at: dayjs(appointment.created_at),
      phone: `+${appointment.phone}`,
      interphone: appointment.box?.interphone,
      box_data: `${appointment.box?.name} - ${appointment.box?.zip_code}`,
      postal_place_id: appointment.postal_place_id,
      created_by: t(`Admin.AppointmentForm.createdBy.${appointment.created_by}`)
    }
    form.setFieldsValue(json)
  }, [appointment])

  const onFinish = (values) => {
    values = { ...values, phone: values.phone.slice(1) }
    saveAppointment(values)
  }

  const saveAppointment = (params) => {
    params = { ...params, begin_date: params.range[0], end_date: params.range[1] }
    setLoading(true)
    put({
      url: `admin/appointments/${appointment.id}`,
      params,
      notification: { api: notificationApi, state: 'update' },
      onSuccess: () => {
        setLoading(false)
      },
      onFailure: (errors) => {
        setLoading(false)
        form.setFields(
          Object.keys(errors).map((key) => ({
            name: key,
            errors: errors[key]
          }))
        )
      }
    })
  }

  return (
    <div style={{ position: 'relative', display: 'flex' }}>
      <AppointmentForm form={form} edit={true} onFinish={onFinish} disabled={appointment.is_cancel}
        specialist={appointment.specialist} postalPlace={appointment.postal_place}
        appointment={appointment} />
    </div >
  )
}
